import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import React from "react";
import RequestAndReceiveCard, { StockItemData, StockStatus, StockTakingType } from "./request-and-receive-card";

const Component: React.FC = () => {
    const stockItems: StockItemData[] = [
        {
            name: "Amoxicillin 500mg",
            request_from: "Dr. Smith",
            quantity: 100,
            status: StockStatus.APPROVED,
            type: StockTakingType.REQUEST,
            created_at: "2024-06-10"
        },
        {
            name: "Paracetamol 500mg",
            request_from: "Dr. Johnson",
            quantity: 200,
            status: StockStatus.PENDING,
            type: StockTakingType.REQUEST,
            created_at: "2024-06-11"
        },
        {
            name: "Ibuprofen 400mg",
            request_from: "Supplier A",
            quantity: 150,
            status: StockStatus.APPROVED,
            type: StockTakingType.RECEIVE,
            created_at: "2024-06-12"
        },
        {
            name: "Metformin 850mg",
            request_from: "Dr. Wilson",
            quantity: 75,
            status: StockStatus.PENDING,
            type: StockTakingType.REQUEST,
            created_at: "2024-06-13"
        },
        {
            name: "Omeprazole 20mg",
            request_from: "Pharma Corp",
            quantity: 300,
            status: StockStatus.RECEIVED,
            type: StockTakingType.RECEIVE,
            created_at: "2024-06-14"
        },
        {
            name: "Lisinopril 10mg",
            request_from: "Dr. Brown",
            quantity: 50,
            status: StockStatus.REJECTED,
            type: StockTakingType.REQUEST,
            created_at: "2024-06-15"
        },
        {
            name: "Atorvastatin 20mg",
            request_from: "MedSupply Ltd",
            quantity: 120,
            status: StockStatus.RECEIVED,
            type: StockTakingType.RECEIVE,
            created_at: "2024-06-16"
        },
        {
            name: "Amlodipine 5mg",
            request_from: "Dr. Davis",
            quantity: 80,
            status: StockStatus.APPROVED,
            type: StockTakingType.REQUEST,
            created_at: "2024-06-17"
        },
        {
            name: "Losartan 50mg",
            request_from: "HealthCare Inc",
            quantity: 200,
            status: StockStatus.PENDING,
            type: StockTakingType.RECEIVE,
            created_at: "2024-06-18"
        },
        {
            name: "Simvastatin 40mg",
            request_from: "Dr. Miller",
            quantity: 60,
            status: StockStatus.PENDING,
            type: StockTakingType.REQUEST,
            created_at: "2024-06-19"
        },
        {
            name: "Furosemide 40mg",
            request_from: "Global Pharma",
            quantity: 90,
            status: StockStatus.APPROVED,
            type: StockTakingType.RECEIVE,
            created_at: "2024-06-20"
        },
        {
            name: "Warfarin 5mg",
            request_from: "Dr. Taylor",
            quantity: 25,
            status: StockStatus.REJECTED,
            type: StockTakingType.REQUEST,
            created_at: "2024-06-21"
        },
        {
            name: "Digoxin 0.25mg",
            request_from: "Dr. Anderson",
            quantity: 30,
            status: StockStatus.APPROVED,
            type: StockTakingType.REQUEST,
            created_at: "2024-06-22"
        },
        {
            name: "Ramipril 5mg",
            request_from: "MediDist Co",
            quantity: 110,
            status: StockStatus.RECEIVED,
            type: StockTakingType.RECEIVE,
            created_at: "2024-06-23"
        },
        {
            name: "Bisoprolol 2.5mg",
            request_from: "Dr. White",
            quantity: 45,
            status: StockStatus.PENDING,
            type: StockTakingType.REQUEST,
            created_at: "2024-06-24"
        }
    ];
    return (
        <div className="flex flex-col items-start justify-start p-4 w-full">
            <Card className="bg-[#FFFFFF] relative border rounded-2xl w-full">
                <CardContent className="w-full p-6 flex flex-col items-start justify-start gap-y-2">
                    <span className="font-semibold text-xl">Request & Receive Stock</span>
                    <span className="font-normal text-base text-gray-400 mb-4">Track stock requests and incoming shipments</span>
                    <div className="flex flex-row items-center justify-between w-full mb-4 gap-x-4">
                        <Input placeholder="Search medication..."/>
                        <Button>Add Request</Button>
                    </div>
                    {stockItems.map((item, index) => (
                        <RequestAndReceiveCard key={index} {...item} />
                    ))}
                </CardContent>
            </Card>
        </div>
    );
}

export default Component;